import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { apiPostAuth } from "../../utils/api";
import "../../App.css";

export default function EditAppPage() {
  const { package_name } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [appName, setAppName] = useState("");
  const [supportEmail, setSupportEmail] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const fetchAppDetails = async () => {
      try {
        const response = await apiPostAuth("google_apps/edit_init.php", {
          app_package_name: package_name,
        });
        if (response.result === 1) {
          setAppName(response.app_data.app_name || "");
          setSupportEmail(response.app_data.app_support_email || "");
        } else {
          alert(response.message || "Failed to load app details");
          navigate(`/dashboard/google-play-review/${package_name}`);
        }
      } catch (error) {
        navigate(`/dashboard/google-play-review/${package_name}`);
      } finally {
        setLoading(false);
      }
    };
    fetchAppDetails();
  }, [package_name, navigate]);

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const response = await apiPostAuth("google_apps/update_app_data.php", {
        app_package_name: package_name,
        app_name: appName,
        app_support: supportEmail,
      });
      if (response.result === 1) {
        alert("App details updated successfully!");
        navigate(`/dashboard/google-play-review/${package_name}`);
      } else {
        alert(response.message || "Failed to update app details");
      }
    } catch (error) {
      alert("Something went wrong.");
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <div className="loading-spinner"></div>
        <p>Loading app details...</p>
      </div>
    );
  }

  return (
    <div style={{ padding: "20px" }}>
      <button
        onClick={() => navigate(`/dashboard/google-play-review/${package_name}`)}
        style={backButtonStyle}
      >
        ← Back to App Dashboard
      </button>

      <h1 style={{ fontSize: "1.8rem", marginBottom: "20px", color: "#1f2937" }}>
        Edit App Details
      </h1>

      <form
        onSubmit={handleSave}
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "8px",
          boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
          maxWidth: "500px",
        }}
      >
        <div style={{ marginBottom: "15px" }}>
          <label style={labelStyle}>App Name</label>
          <p style={{ fontSize: "0.85rem", color: "#6b7280", marginTop: "6px" }}>
            This name will be used when the AI refers to your app in responses.
          </p>
          <input
            type="text"
            value={appName}
            onChange={(e) => setAppName(e.target.value)}
            style={inputStyle}
            required
          />
        </div>
        <div style={{ marginBottom: "15px" }}>
          <label style={labelStyle}>App Support Email</label>
          <p style={{ fontSize: "0.85rem", color: "#6b7280", marginTop: "6px" }}>
            This email will be included in responses where users are encouraged
            to contact support or provide additional details.
          </p>
          <input
            type="email"
            value={supportEmail}
            onChange={(e) => setSupportEmail(e.target.value)}
            style={inputStyle}
            required
          />
        </div>
        <button
          type="submit"
          className="primary-button"
          disabled={saving}
        >
          {saving ? "Saving..." : "Save Changes"}
        </button>
        <p style={{ fontSize: "0.85rem", color: "#6b7280", marginTop: "6px" }}>
          This changes will take effect immediately if the automation is running.
        </p>
      </form>
    </div>
  );
}

const labelStyle = {
  display: "block",
  marginBottom: "6px",
  fontWeight: "500",
  color: "#1f2937",
};

const inputStyle = {
  width: "90%",
  padding: "10px",
  border: "1px solid #ccc",
  borderRadius: "6px",
  fontSize: "1rem",
};

const backButtonStyle = {
  display: "inline-block",
  padding: "8px 16px",
  backgroundColor: "#f2f6fc",
  color: "#2563eb",
  fontWeight: "500",
  border: "1px solid #d1d5db",
  borderRadius: "6px",
  cursor: "pointer",
  marginBottom: "20px",
  transition: "all 0.2s ease",
};
